import { useRef, useEffect } from 'react';
import { motion, animate } from 'motion/react';
import { SelectionButtonOdds } from '../../components/selection-button';

const AnimatedSelectionButtonOdds = motion(SelectionButtonOdds);

type OddsChangeCounterProps = {
	odds: number;
	renderOdds: (odds: number) => string;
};

const OddsChangeCounter: React.FC<OddsChangeCounterProps> = ({ odds, renderOdds }) => {
	const nodeRef = useRef<HTMLDivElement | null>(null);
	const previousOdds = useRef(odds);

	useEffect(() => {
		const node = nodeRef.current;

		if (!node) {
			return;
		}

		const controls = animate(previousOdds.current, odds, {
			duration: 1,
			ease: [0.39, 0.18, 0.82, 0.55],
			onUpdate(value) {
				if (Number.isNaN(value)) {
					// If value is NaN we are currently updating the odds, and the selection box is disabled for the time being and we should not display anything
					node.textContent = '';
					return;
				}
				node.textContent = renderOdds(value);
			}
		});

		previousOdds.current = odds;

		return () => controls.stop();
	}, [odds, renderOdds]);

	return <AnimatedSelectionButtonOdds ref={nodeRef} />;
};

export default OddsChangeCounter;
